import React from 'react';

function PageHeader({ title, subtitle, crumbs = ['गृहपृष्ठ', title] }) {
  return (
    <header className="mb-6">
      <nav className="flex items-center gap-2 text-[12px] font-semibold text-muted mb-2 flex-wrap" aria-label="breadcrumb">
        {crumbs.map((c, i) => (
          <React.Fragment key={i}>
            {i > 0 && <span className="opacity-50">/</span>}
            <span className={i === crumbs.length - 1 ? 'text-crimson' : ''}>{c}</span>
          </React.Fragment>
        ))}
      </nav>
      <h1 className="font-display text-[clamp(22px,3vw,32px)] font-bold text-ink leading-tight">{title}</h1>
      {subtitle && <p className="text-muted text-sm mt-1.5 max-w-[640px] leading-relaxed">{subtitle}</p>}
    </header>
  );
}

export default PageHeader;